let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iXbSM")).then(() => parcelRequire('gytUr'));